<!--
 * @Description: 学生花名册 列表
 * @Author: PF
 * @Date: 2023-01-05 15:11:27
 * @LastEditors: PF
 * @LastEditTime: 2024-06-24 16:56:13
-->

<template>
  <div>
    <el-dialog class="wp90 h800" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close style="min-width: 1030;">
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Suitcase />
          </el-icon>
          <span class="header-title">学生花名册</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-aside width="200px">
            <el-tree :data="bjsall" default-expand-all highlight-current :props="{ children: 'children', label: 'mc'}" @node-click="handleNodeClick" />
          </el-aside>
          <el-container>
            <el-header>
              <!-- 按钮区域 -->
              <div class="top_but">
                <div class="but_group">
                </div>
                <div class="top-total">
                  班级名称：<span>{{ bjmc }}</span>
                  男生人数：<span>{{ nansrs }}</span>
                  女生人数：<span>{{ nvsrs }}</span>
                </div>
              </div>
            </el-header>
            <el-main>
              <el-table :data="tableData" style="width: 100%" border v-loading="loading" height="100%">
                <el-table-column prop="xh" label="学号" align="center" show-overflow-tooltip />
                <el-table-column prop="xm" label="学生姓名" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <el-link type="primary" @click="openDetail=true;row=scope.row">{{scope.row.xm}}</el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="xb" label="性别" align="center" show-overflow-tooltip />
                <el-table-column label="当前状态" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <span v-for="(item, index) in xjztData.list" :key="index">
                      <span v-if="scope.row.xsdqzt === item.value">{{item.label}}</span>
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </el-main>
            <el-footer>
              <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
            </el-footer>
          </el-container>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { actionPost, homeCloseWindow } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'
import { getXjzt } from '@/utils/meiju.js'
import pagination from '@/components/pagination.vue'
import detail from '@/components/xuesheng/detail'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

// 内容区域 开始
const loading = ref(false) // 加载
const tableData = ref() // 内容列表
const bjsall = ref() // 班级树
const bjid = ref([]) // 左侧班级id
const bjmc = ref() // 班级名称
const nansrs = ref() // 男生人数
const nvsrs = ref() // 女生人数
// 分页
const paginationObj = ref() // 分页
const total = ref(0) // 总条数
// 弹窗
const row = ref()
const openDetail = ref(false)
const openList = ref(false)

// 点击树形控件
const handleNodeClick = (item) => {
  bjid.value = item.id
  bjmc.value = item.mc
  nansrs.value = item.nansrs
  nvsrs.value = item.nvsrs
  initList()
}

// 列表
const initList = async (pageNo, pageSize) => {
  loading.value = true
  const info = {
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    bjid: bjid.value
  }
  actionPost({ url: '/api/v2/pdp/xuesheng/pagelist', data: info }).then((res) => {
    if (res.code === 200) {
      loading.value = false
      paginationObj.value = {
        pageNo: info.pageNo,
        pageSize: info.pageSize,
        total: res.data.total
      }
      tableData.value = res.data.list
      total.value = res.data.total
    } else {
      warningPrompt(res.message)
    }
  })
}
// 班级列表
const initBanJiList = () => {
  actionPost({ url: '/api/v2/pdp/banji/tree', data: {} }).then((res) => {
    if (res.code === 200) {
      bjsall.value = res.data
    } else {
      warningPrompt(res.message)
    }
  })
}
const xjztData = ref({ list: [] })
watch(
  () => props.open,
  () => {
    if (props.open === 'xueshenghuamingce') {
      xjztData.value = getXjzt()
      openList.value = true
      initBanJiList()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
// 自动执行 结束
</script>

<style lang="less" scoped>
.top-total {
  span{
    margin-right: 10px;
    color:  #529b2e;
  }
}
</style>
